module.exports = __webpack_public_path__ + "static/media/PDF_62.971e62e5.pdf";